import { render } from "./TaqsimotJadval.vue?vue&type=template&id=19314592&scoped=true"
import script from "./TaqsimotJadval.vue?vue&type=script&lang=js"
export * from "./TaqsimotJadval.vue?vue&type=script&lang=js"

import "./TaqsimotJadval.vue?vue&type=style&index=0&id=19314592&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19314592"]])

export default __exports__